import { render, staticRenderFns } from "./phone-validation-chip.vue?vue&type=template&id=9d28e25a&scoped=true&"
import script from "./phone-validation-chip.vue?vue&type=script&lang=js&"
export * from "./phone-validation-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d28e25a",
  null
  
)

export default component.exports